import { searchResponseAdapter } from '@wwt/api/base/base'

import { getMockSearchResponseValue, validateServerData } from '@wwt/core/admin'
import {
	SearchOffersDto,
	SearchResponseDto
} from '@wwt/entities/api/search-response'
import { searchOffersToUrlSearchParams } from '@wwt/shared/utils/searchRequestToURLSearchParams/searchRequestToUrlSearchParams.ts'

import { api } from '@/shared/api/client'
import * as Errors from '@/shared/lib/errors'

import { searchResponseWrapper } from '../validator/searchResponseWrapper'

export const searchQuery = async (
	searchOffers: SearchOffersDto,
	pageParam: number,
	signal: AbortSignal
) => {
	const urlSearchParams = searchOffersToUrlSearchParams(searchOffers)

	urlSearchParams.set('pagination.offset', String(pageParam))

	const searchResponseMocked = getMockSearchResponseValue()

	// TODO: refactor this
	let response: Response

	if (import.meta.env.VITE_USE_MOCK_SEARCH_DATA === 'true') {
		response = await fetch(import.meta.env.VITE_USE_MOCK_SEARCH_DATA_PATH)
	} else if (searchResponseMocked[0] && searchResponseMocked[1] !== null) {
		response = new Response(searchResponseMocked[1], {
			headers: { 'Content-Type': 'application/json' },
			status: 200
		})
	} else {
		response = await api('res')
			.options({ signal })
			.query(urlSearchParams.toString())
			.get('/v1/offers/search')
			.notFound(error => {
				throw new Errors.NotFoundError('Not found', error.json)
			})
			.res()
	}

	const serverResponse = await searchResponseWrapper<unknown>(response)

	return searchResponseAdapter(
		await validateServerData(serverResponse, SearchResponseDto, 'Search')
	)
}
